import { SisternodeOutlined } from '@ant-design/icons';
import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import { type IReferencePath } from '../../../../expressions/references/IReferencePath.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema.ts';
import { createSwitchWidgetSchema } from './createSwitchWidgetSchema.tsx';
import { type ISwitchWidget } from './ISwitchWidget.ts';
import { ScoreWidgetPreviewComponent } from './ScoreWidgetPreviewComponent.tsx';
import { SwitchWidgetComponent } from './SwitchWidgetComponent.tsx';
import { SwitchWidgetConfigComponent } from './SwitchWidgetConfigComponent.tsx';
import { SwitchWidgetConfigSchema } from './SwitchWidgetConfigSchema.ts';

export const SwitchWidgetType: IWidgetType<ISwitchWidget> = {
  type: WidgetType.Switch,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  name: 'Valore condizionale',
  icon: <SisternodeOutlined aria-hidden />,
  hasValue: true,
  getReference: (path: IReferencePath, widget: ISwitchWidget): IReference => ({
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: widget.datatype,
    },
  }),
  formComponent: SwitchWidgetComponent,

  createFormSchema: input => {
    return createCommonFormSchema(
      createSwitchWidgetSchema(input),
      input.widget,
    );
  },
  previewComponent: ScoreWidgetPreviewComponent,
  configComponent: SwitchWidgetConfigComponent,
  configValidator: SwitchWidgetConfigSchema,
  rules: [],
  translationSchema: tran.widget(),
  dynamicReference: true,
  alwaysEnabled: true,
};
